import { defineMessages } from 'react-intl';

export default defineMessages({
  emailAddressLabel: {
    id: 'welcome.form.email.verified.label',
    defaultMessage: 'Email address',
  },
});
